import { LocaleWrapper } from '..';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';

import { LayoutWrapper } from '../../../layouts';
import { ViewOtherRestaurantsButton } from './restaurant-job-positions';

export const RestaurantNotFound = () => {
  const { t: showcasePageT } = useTranslation('restaurant-showcase-page');
  return (
    // Same treatment as the showcase it stands in for: the two locales of a
    // venue are generated separately, so one could serve the venue while the
    // other serves this page, and only a shared mode keeps them consistent.
    <LayoutWrapper hasFooter hasNavbar title="Locale" seoProps={{ noindex: true }} languageSeoMode="consolidated">
      <LocaleWrapper>
        <div className="flex flex-col items-center justify-start h-full w-full gap-0">
          <Image
            src={getAssetSrc('/utils-assets/not-found.svg')}
            width={238}
            height={220}
            alt="restaurant_not_found"
            loader={customImageLoader}
          />
          <div className="flex flex-col items-center lg:w-[411px] w-full mt-2.5 mb-8 text-center">
            <Heading size={4}>{showcasePageT('we_are_sorry')} 😔</Heading>
            <Heading size={4}>{showcasePageT('cant_find_restaurant')}.</Heading>
            <Heading size={5} color="muted" weight="normal" className="mt-4">
              {showcasePageT('plenty_of_offer')}!
            </Heading>
          </div>
          <div className="lg:w-[325px] w-full">
            <ViewOtherRestaurantsButton />
          </div>
        </div>
      </LocaleWrapper>
    </LayoutWrapper>
  );
};
